import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const getAllReviews = async (
  page,
  size,
  sort,
  sortBy,
  status,
  parkingAreaId,
  filter,
  search,
) => {
  const params = new URLSearchParams({ page, size, sort, sortBy });
  if (status != null) params.append("status", status);
  if (parkingAreaId != null) params.append("parkingAreaId", parkingAreaId);
  if (filter != null) params.append("filter", filter);
  if (search != null) params.append("search", search);
  return axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/reviews?${params.toString()}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } },
  );
};

export const approveReview = async (id) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/reviews/${id}/approve`,
    {},
    { headers: { Authorization: `Bearer ${getJwtToken()}` } },
  );

export const rejectReview = async (id) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/reviews/${id}/reject`,
    {},
    { headers: { Authorization: `Bearer ${getJwtToken()}` } },
  );

export const deleteReview = async (id) =>
  axiosApiInstance.delete(`${PARKIT_API_BASE_URL}/parkit/v2/reviews/${id}`, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });
